// 📄 components/StepHesParams.tsx
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { HesFormData } from '../../../../../services/commerce/integrationService';

interface StepHesParamsProps {
  entrySheetCreateTimeout: string;
  onChange: (field: keyof HesFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepHesParams({ entrySheetCreateTimeout, onChange, isInvalid }: StepHesParamsProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">SPRO</span>
          <span>Integration with Other SAP Components → SAP Ariba Cloud Integration Gateway → Application-Specific Settings → Service Entry Sheet → Maintain Parameters</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">1. Maintain Parameters (Timeout de Creación)</h3>
        <p className="text-sm text-gray-400">
          Define el tiempo máximo de espera para la creación de la Hoja de Entrada de Servicios (HES) generada desde SAP Ariba.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 max-w-sm">
        <label className="block text-xs font-medium text-gray-400 mb-1">
          Parámetro <code className="bg-black/30 px-1 rounded font-mono text-blue-400">ENTRYSHEET_CREATE</code> · Field <code className="bg-black/30 px-1 rounded font-mono text-blue-400">TIMEOUT</code> <span className="text-red-400">*</span>
        </label>
        <input
          type="text"
          value={entrySheetCreateTimeout}
          onChange={(e) => onChange('entrySheetCreateTimeout', e.target.value.replace(/[^0-9]/g, ''))}
          placeholder="20"
          maxLength={3}
          className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
            isInvalid && !entrySheetCreateTimeout ? 'border-red-500' : 'border-white/10'
          }`}
        />
        <p className="text-[10px] text-gray-500 mt-1">Valor bajo (Low) en segundos, ej. 20</p>
      </div>

      <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 text-blue-400 flex gap-3 text-sm">
        <AlertCircle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Impacto en órdenes de servicio de alto volumen</p>
          <p className="text-xs text-blue-400/80 mt-0.5">
            Si el pedido de servicio tiene muchas líneas, considera aumentar este timeout para evitar que la creación de la HES falle por tiempo de espera agotado.
          </p>
        </div>
      </div>
    </div>
  );
}
